module.exports = __webpack_public_path__ + "images/dropdown-selected-693ecff7.svg";